"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

const BookTailorInfo = () => {
  const t = useTranslations("bookTailorInfo");

  return (
    <div className="max-w-[740px] w-full mx-auto px-5">
      <div className="flex items-center space-x-3 justify-center md:justify-start">
        <div className="w-14 h-14 relative">
          <Image
            src="/images/logo-circle.svg"
            alt="Book Tailor Logo"
            fill
            style={{ objectFit: 'contain' }}
          />
        </div>
        <div className="text-[#2b2b2b] font-inter">
          <p className=" font-semibold ">{t("companyName")}</p>
          <p className="">
            {t("locatedAt")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default BookTailorInfo;
